/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";

import { Bars3Icon } from "@heroicons/react/24/outline";
import api from "../../api";
import Sidebar from "../../components/Sidebar";
import Breadcrumbs from "../../components/Breadcrumbs";
import { useNavigate, useParams } from "react-router-dom";
import FormNewConsultation from "../../components/FormNewConsultation";
import InlineCheckbox from "../../components/InlineCheckbox";
import { Dialog } from "@headlessui/react";
import Modal from "../../components/Modal";
import SelectInput from "../../components/SelectInput";
import TextInput from "../../components/TextInput";
import TextArea from "../../components/TextArea";
import Table from "../../components/Table";
import TextEditor from "../../components/TextEditor";
import FileInput from "../../components/FileInput";
import toast, { Toaster } from "react-hot-toast";

let tabs = [
    { name: "Visión y Tensión", current: true },
    { name: "Refracción", current: false },
    { name: "Medicación", current: false },
    { name: "Estudios oftalmológicos", current: false },
    { name: "Estudios clínicos", current: false },
    // { name: 'Cirugía', current: false },
    // { name: 'Ecobiometría', current: false },
];

const columns = [
    { name: "uploadDate", displayText: "Fecha" },
    { name: "name", displayText: "Nombre del archivo", truncate: true },
];

const consultationTypes = [
    { name: "General", value: 1 },
    { name: "De especialidad", value: 2 },
];

const constancyTypes = [
    { name: "Constancia de reposo", value: 1 },
    { name: "Asistencia a consulta", value: 2 },
];

const consultationASubtypes = [
    { name: "Control de rutina", value: 4 },
    { name: "Control por tratamiento", value: 1 },
    { name: "Control post quirúrgico", value: 2 },
    { name: "Estudios", value: 3 },
];

const consultationBSubtypes = [
    { name: "Control por tratamiento", value: 1 },
    { name: "Control post quirúrgico", value: 2 },
    { name: "Estudios", value: 3 },
];

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const getAge = (dateString) => {
    if (!dateString) return null;
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
};

export default function ConsultationNewPage() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [loading, setLoading] = useState(false);
    const [history, setHistory] = useState([]);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [loadingSubmitRecords, setLoadingSubmitRecords] = useState(false);
    const [loadingSubmitConstancy, setLoadingSubmitConstancy] = useState(false);
    const [openRecords, setOpenRecords] = useState(false);
    const [openLastsPrescription, setOpenLastsPrescription] = useState(false);
    const [openConstancies, setOpenConstancies] = useState(false);
    const [openDocuments, setOpenDocuments] = useState(false);
    const [constancyType, setConstancyType] = useState(1);
    const [constancy, setConstancy] = useState(undefined);
    const [documents, setDocuments] = useState([]);
    const [submitError, setSubmitError] = useState("");
    const [downloadError, setDownloadError] = useState("");
    const [hasSelectedType, setHasSelectedType] = useState(true);
    const [hasSelectedSubtype, setHasSelectedSubtype] = useState(true);
    const [patientDocument, setPatientDocument] = useState({ documents: [] });
    const { idPatient } = useParams();
    const { idConsultation: urlIdConsultation } = useParams();
    const [idConsultation, setIdConsultation] = useState(urlIdConsultation);
    const [tab, setTab] = useState("Visión y Tensión");
    const [printInsurance, setPrintInsurance] = useState("");
    // eslint-disable-next-line no-unused-vars
    const [userId, setUserId] = useState(
        JSON.parse(localStorage.getItem("BDOuserData"))?.id
    );
    const [patient, setPatient] = useState([]);
    const [medicines, setMedicines] = useState([]);
    const [surgeries, setSurgeries] = useState([]);
    const [doctors, setDoctors] = useState([]);
    const navigate = useNavigate();
    const [consultation, setConsultation] = useState({
        patient: parseInt(idPatient),
        doctor: userId,
        consultationDate: new Date().toISOString().split("T")[0],
        consultationCategory: 2,
        consultationType: 1,
    });
    const initialConsultationRef = useRef(consultation);
    const [errors, setErrors] = useState({});
    const handleChange = (field, value) =>
        setConsultation((prev) => ({ ...prev, [field]: value }));
    const handlePatient = (field, value) =>
        setPatient((prev) => ({ ...prev, [field]: value }));
    const handleError = (field, value) =>
        setErrors((prev) => ({ ...prev, [field]: value }));
    const handleConstancyType = (field, value) => setConstancyType(value);
    const handleConstancy = (field, value) => {
        if (field === "restDays")
            setConstancy((prev) => ({ ...prev, [field]: parseInt(value) }));
        else setConstancy((prev) => ({ ...prev, [field]: value }));
    };
    const today = new Date();

    const notify = (message, type = "success") => {
        toast(message, {
            style: {
                background: type === "success" ? "#4caf50" : "#f44336",
                color: "#fff",
                padding: "16px",
                borderRadius: "8px",
            },
            duration: 4000,
        });
    };

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            const formHasChanges =
                JSON.stringify(consultation) !==
                JSON.stringify(initialConsultationRef.current);
            if (formHasChanges) {
                event.preventDefault();
                event.returnValue = "";
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [consultation]);

    useEffect(() => {
        api.patients.getHistory(idPatient, "date").then(
            (response) => (
                setHistory({
                    ...response,
                    consultationList: response.consultationList
                        ? response.consultationList.map((element, idx) => ({
                              ...element,
                              index: idx + 1,
                              prescription: element.prescription ? "Si" : "No",
                          }))
                        : undefined,
                })
            )
        );
        api.patients
            .getOne(idPatient)
            .then((response) => {
                setPatient({
                    ...response,
                    name: response.firstName + " " + response.lastName,
                });
            })
            .catch((error) => console.log(error));
        api.medicines.getMulti().then((response) => {
            setMedicines(response);
        });
        api.surgeries.getMulti().then((response) => {
            setSurgeries(response);
        });
        api.users.getDoctors().then((response) => {
            setDoctors(
                response.map((element) => ({
                    name: `${element.sex === "Masculino" ? "Dr." : "Dra."} ${
                        element.firstName
                    } ${element.lastName}`,
                    ...element,
                }))
            );
        });
    }, []);

    useEffect(() => {
        if (urlIdConsultation) {
            setIdConsultation(urlIdConsultation);
            api.consultations.getOne(urlIdConsultation).then((response) => {
                setConsultation(response);
                setDocuments(response.documents);
            });
        }
    }, [urlIdConsultation]);

    useEffect(() => {
        if (openConstancies)
            setConstancy({
                patient: parseInt(idPatient),
                doctor: userId,
            });
        setDownloadError("");
    }, [openConstancies]);

    useEffect(() => {
        if (constancyType === 2)
            setConstancy({
                patient: parseInt(idPatient),
                doctor: userId,
                text: `Certifico por la presente que ${
                    patient?.sex === 1 ? "el" : "la"
                } paciente ${
                    patient?.name
                } acudió a la consulta oftalmológica en fecha ${today.getDate()} de ${today.toLocaleString(
                    "es-PY",
                    { month: "long" }
                )} de ${today.getFullYear()}.
\nSe expide este certificado para lo que hubiere lugar.`,
            });
        else if (constancyType)
            setConstancy({
                patient: parseInt(idPatient),
                doctor: userId,
            });
        setDownloadError("");
    }, [constancyType]);

    useEffect(() => {
        tabs[tabs.findIndex((tab) => tab.current)].current = false;
        tabs[
            tabs.findIndex((tab) => tab.name === "Visión y Tensión")
        ].current = true;
    }, []);

    const pages = [
        { name: "Pacientes", href: "/patients", current: false },
        {
            name: `${patient.name}`,
            href: `/patients/${idPatient}`,
            current: false,
        },
        {
            name: idConsultation ? "Ver consulta" : "Nueva consulta",
            href: "#",
            current: true,
        },
    ];

    const changeTab = (value) => {
        let error = false;
        if (
            tabs[tabs.findIndex((tab) => tab.current)].name ===
            "Visión y Tensión"
        ) {
            if (!error) {
                tabs[tabs.findIndex((tab) => tab.current)].current = false;
                tabs[
                    tabs.findIndex((tab) => tab.name === value)
                ].current = true;
                setTab(tabs[tabs.findIndex((tab) => tab.current)].name);
            }
        } else {
            tabs[tabs.findIndex((tab) => tab.current)].current = false;
            tabs[tabs.findIndex((tab) => tab.name === value)].current = true;
            setTab(tabs[tabs.findIndex((tab) => tab.current)].name);
        }
    };

    const checkIfEmpty = (medication) => {
        if (
            medication.medicine ||
            medication.periodNumber !== "" ||
            medication.quantity !== "" ||
            medication.frequencyNumber !== "" ||
            medication.observations !== ""
        )
            return false;
        else return true;
    };

    const validateConsultation = (consultation) => {
        let validationErrors = {};
        let hasError = false;
        let errorTab = "Visión y Tensión";
        const meds = consultation.medications || [];

        const isEmptyHtml = (value) => {
            if (!value) return true;
            const noTags = value
                .replace(/<[^>]*>/g, "")
                .replace(/&nbsp;/g, " ")
                .trim();
            return noTags === "";
        };

        const isMedicationRowEmpty = (m) => {
            if (!m) return true;
            return !(
                m.medicine ||
                (m.quantity !== undefined &&
                    m.quantity !== null &&
                    String(m.quantity).trim() !== "") ||
                (m.frequencyNumber !== undefined &&
                    m.frequencyNumber !== null &&
                    String(m.frequencyNumber).trim() !== "") ||
                (m.periodNumber !== undefined &&
                    m.periodNumber !== null &&
                    String(m.periodNumber).trim() !== "") ||
                (m.observations !== undefined &&
                    m.observations !== null &&
                    String(m.observations).trim() !== "")
            );
        };

        const isPositiveInt = (v) =>
            /^\d+$/.test(String(v).trim()) && parseInt(v, 10) > 0;

        // Validaciones de Medicación
        if (meds.length > 0) {
            const medsErrors = [];
            meds.forEach((m, idx) => {
                if (isMedicationRowEmpty(m)) return;
                const rowErrors = {};
                if (!m?.medicine)
                    rowErrors.medicine = "Este campo es obligatorio";
                if (
                    m?.quantity === undefined ||
                    m?.quantity === null ||
                    String(m.quantity).trim() === ""
                ) {
                    rowErrors.quantity = "Este campo es obligatorio";
                } else if (!isPositiveInt(m.quantity)) {
                    rowErrors.quantity = "Debe ser un número entero mayor a 0";
                }
                if (!m?.presentation)
                    rowErrors.presentation = "Este campo es obligatorio";
                if (
                    m?.frequencyNumber === undefined ||
                    m?.frequencyNumber === null ||
                    String(m.frequencyNumber).trim() === ""
                ) {
                    rowErrors.frequencyNumber = "Este campo es obligatorio";
                } else if (!isPositiveInt(m.frequencyNumber)) {
                    rowErrors.frequencyNumber =
                        "Debe ser un número entero mayor a 0";
                }
                if (!m?.frequency)
                    rowErrors.frequency = "Este campo es obligatorio";
                // if (!m?.period) rowErrors.period = "Este campo es obligatorio";
                // periodNumber obligatorio SIEMPRE que exista medicación, excepto "De por vida" (period === 5)
                // if (m?.period !== 5) {
                //     if (
                //         m?.periodNumber === undefined ||
                //         m?.periodNumber === null ||
                //         String(m.periodNumber).trim() === ""
                //     ) {
                //         rowErrors.periodNumber = "Este campo es obligatorio";
                //     } else if (!isPositiveInt(m.periodNumber)) {
                //         rowErrors.periodNumber =
                //             "Debe ser un número entero mayor a 0";
                //     }
                // }
                // Validar que eye sea obligatorio cuando presentation es Colirio (id: 1)
                if (m?.presentation === 1) {
                    if (!m?.eye) {
                        rowErrors.eye =
                            "El campo ojo es obligatorio cuando la presentación es colirio";
                    }
                }
                if (Object.keys(rowErrors).length > 0) {
                    medsErrors[idx] = rowErrors;
                }
            });
            if (medsErrors.some(Boolean)) {
                validationErrors.medications = medsErrors;
                if (!hasError) {
                    hasError = true;
                    errorTab = "Medicación";
                } else {
                    hasError = true;
                }
            }
        }

        // Validaciones de Refracción
        if (consultation.refraction) {
            const refr = consultation.refraction;

            // const decimalFields = [
            //     "farVisionSphericalRight",
            //     "farVisionSphericalLeft",
            //     "farVisionCylindricalRight",
            //     "farVisionCylindricalLeft",
            //     "nearVisionSphericalRight",
            //     "nearVisionSphericalLeft",
            //     "nearVisionCylindricalRight",
            //     "nearVisionCylindricalLeft",
            // ];

            // const isDecimalWithSign = (value) =>
            //     /^[-+]?\d+(\.\d+)?$/.test(value);

            // decimalFields.forEach((field) => {
            //     const value = refr[field];
            //     if (value !== undefined && value !== null && value !== "") {
            //         const str = String(value).trim();
            //         if (!isDecimalWithSign(str)) {
            //             validationErrors[field] =
            //                 "Debe ser un número decimal con o sin signo";
            //             hasError = true;
            //             errorTab = "Refracción";
            //         }
            //     }
            // });

            if (
                refr.intrapupillaryDistance !== undefined &&
                refr.intrapupillaryDistance !== null &&
                refr.intrapupillaryDistance !== ""
            ) {
                const intValue = String(refr.intrapupillaryDistance).trim();
                if (!/^\d+$/.test(intValue)) {
                    validationErrors.intrapupillaryDistance =
                        "Debe ser un número entero";
                    hasError = true;
                    errorTab = "Refracción";
                }
            }
        }

        // Validar campos de Visión y Tensión
        if (isEmptyHtml(consultation.visionTension?.motiveOfConsultation)) {
            validationErrors.motiveOfConsultation = "Este campo es obligatorio";
            hasError = true;
            errorTab = "Visión y Tensión";
        }

        if (
            !consultation.visionTension?.diagnoses ||
            consultation.visionTension?.diagnoses.length === 0
        ) {
            validationErrors.diagnoses = "Este campo es obligatorio";
            hasError = true;
            errorTab = "Visión y Tensión";
        }

        return { hasError, errorTab, validationErrors };
    };

    const handleSubmit = async (event, finish) => {
        event.preventDefault();

        setErrors({});
        const { hasError, errorTab, validationErrors} =
            validateConsultation(consultation);

        if (hasError) {
            Object.keys(validationErrors).forEach((field) => {
                handleError(field, validationErrors[field]);
            });
            tabs[tabs.findIndex((tab) => tab.current)].current = false;
            tabs[tabs.findIndex((tab) => tab.name === errorTab)].current = true;
            setTab(errorTab);
            return;
        }

        let request = { ...consultation };
        setLoadingSubmit(true);
        setSubmitError("");

        if (request.medications) {
            const nonEmptyMedications = request.medications.filter(
                (element) => !checkIfEmpty(element)
            );

            if (nonEmptyMedications.length === 0) {
                request = { ...request, medications: [] };
            } else {
                request = {
                    ...request,
                    medications: nonEmptyMedications.map((element) =>
                        element.period === 5
                            ? { ...element, periodNumber: 0 }
                            : element
                    ),
                };
            }
        }

        let diagnosesIds = [];
        if (request.visionTension?.diagnoses) {
            diagnosesIds = request.visionTension.diagnoses
                .map((d) => {
                    if (typeof d === "number") return d;
                    if (typeof d === "object" && d !== null && d.id)
                        return d.id;
                    if (typeof d === "string" && !isNaN(d))
                        return parseInt(d, 10);
                    return null;
                })
                .filter((id) => id !== null);
        }

        const payload = {
            ...request,
            visionTension: {
                ...request.visionTension,
                diagnoses: diagnosesIds,
            },
        };

        try {
            const response = idConsultation
                ? await api.consultations.update(idConsultation, payload)
                : await api.consultations.create(payload);

            const consultationId = idConsultation || response.id;

            if (!idConsultation && response.id) {
                setIdConsultation(response.id);
            }
            await uploadDocumentsForConsultation(consultationId);
            
            if (finish) {
                try {
                    const today = new Date();
                    const todayStr = today.toISOString().split('T')[0];
                    
                    const filterParams = {
                        patient: parseInt(idPatient),
                        doctor: userId,
                        attended: false,
                        missed_appointment: false,
                        date: todayStr,
                    };
                    
                    const turnsResponse = await api.turns.getMulti(
                        null,
                        null,
                        null,
                        null,
                        filterParams
                    );
                    
                    if (turnsResponse && turnsResponse.length > 0) {
                        const activeTurn = turnsResponse[0];
                        await api.turns.update(activeTurn.id, { attended: true });
                    }
                } catch (turnError) {
                    console.error("Error al marcar turno como atendido:", turnError);
                }
                
                navigate(`/patients/${idPatient}`);
            }
            notify("Datos guardados exitosamente", "success");
            setLoadingSubmit(false);
        } catch (error) {
            console.error("Error al guardar consulta:", error);

            if (error.message) {
                if (typeof error.message === "object") {
                    setSubmitError(error.message);

                    if (error.message.medications) {
                        tabs[
                            tabs.findIndex((tab) => tab.current)
                        ].current = false;
                        tabs[
                            tabs.findIndex((tab) => tab.name === "Medicación")
                        ].current = true;
                        setTab("Medicación");
                    }
                } else {
                    setSubmitError({ detail: error.message });
                }
            } else if (error.code === "serverError") {
                setSubmitError({
                    detail: "Error del servidor. Por favor, intente nuevamente.",
                });
            } else {
                setSubmitError({
                    detail: "Error inesperado. Por favor, intente nuevamente.",
                });
            }

            setLoadingSubmit(false);
        }
    };

    const handleSubmitPatient = () => {
        setLoadingSubmitRecords(true);
        api.patients
            .update(idPatient, patient)
            .then((response) => {
                console.log(response);
                setLoadingSubmitRecords(false);
                setOpenRecords(false);
            })
            .catch((error) => {
                setLoadingSubmitRecords(false);
            });
    };

    const submitConstancy = () => {
        if (constancyType) {
            setLoadingSubmitConstancy(true);
            setDownloadError("");
            if (constancyType === 1)
                api.doctorsNote
                    .get({
                        ...constancy,
                        printInsurance,
                        diagnosisId:
                            consultation?.visionTension?.diagnoses?.[0]?.id,
                    })
                    .then(
                        (res) => {
                            setLoadingSubmitConstancy(false);
                            const url = window.URL.createObjectURL(
                                new Blob([res])
                            );
                            const link = document.createElement("a");
                            link.href = url;
                            link.setAttribute(
                                "download",
                                "ConstanciaReposo.pdf"
                            );
                            document.body.appendChild(link);
                            link.click();
                        },
                        async (err) => {
                            setDownloadError(
                                JSON.parse(await err.response.data.text())
                                    .detail
                            );
                            setLoadingSubmitConstancy(false);
                        }
                    );
            else if (constancyType === 2)
                api.consultationAttendance
                    .get({ ...constancy, printInsurance })
                    .then(
                    (res) => {
                        setLoadingSubmitConstancy(false);
                        const url = window.URL.createObjectURL(new Blob([res]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", "AsistenciaConsulta.pdf");
                        document.body.appendChild(link);
                        link.click();
                    },
                    async (err) => {
                        setDownloadError(
                            JSON.parse(await err.response.data.text()).detail
                        );
                        setLoadingSubmitConstancy(false);
                    }
                );
        }
    };

    const handleFileSelect = (files) => {
        const mapped = files.map((file) => ({
            file,
            name: file.name.split(".")[0],
            extension: file.name.split(".").pop(),
        }));

        setPatientDocument((prev) => ({
            ...prev,
            documents: [...prev.documents, ...mapped],
        }));
    };

    const uploadDocumentsForConsultation = async (consultationId) => {
        if (!patientDocument.documents.length) return;

        const uploadDate = new Date().toISOString().split("T")[0];

        const uploadPromises = patientDocument.documents.map((doc) => {
            const finalName = `${doc.name}.${doc.extension}`;

            const formData = new FormData();
            formData.append("patient", idPatient.toString());
            formData.append("consultation", consultationId);
            formData.append("document", doc.file);
            formData.append("name", finalName);
            formData.append("uploadedBy", userId);
            formData.append("uploadDate", uploadDate);

            return api.documents.create(formData);
        });

        await Promise.all(uploadPromises);

        // si quieres, limpiar el buffer local después:
        setPatientDocument({ documents: [] });
    };

    const patientRecords = (
        <>
            <div className="overflow-auto max-h-[80dvh]">
                <div className="mt-3 text-left sm:mt-5">
                    <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900 dark:text-white"
                    >
                        Antecedentes del paciente
                    </Dialog.Title>
                    <div className="flex-col space-y-8 sm:space-y-4 p-2 sm:py-5 sm:p-6 w-full">
                        <div>
                            <label className="font-semibold text-gray-700 dark:text-gray-200">
                                Antecedente personal
                            </label>
                        </div>
                        <div>
                            <div className="grid grid-cols-2 sm:grid-cols-3 px-4 gap-y-4 w-full">
                                <InlineCheckbox
                                    value={patient?.dm}
                                    handleChange={handlePatient}
                                    name="dm"
                                    label="DM"
                                />
                                <InlineCheckbox
                                    value={patient?.hta}
                                    handleChange={handlePatient}
                                    name="hta"
                                    label="HTA"
                                />
                                <InlineCheckbox
                                    value={patient?.gl}
                                    handleChange={handlePatient}
                                    name="gl"
                                    label="Glaucoma"
                                />
                            </div>
                            <TextEditor
                                name="othersPersonal"
                                label=""
                                value={patient?.othersPersonal}
                                handleChange={handlePatient}
                                error={null}
                                required={false}
                                containerClassName="px-4 pb-10 mt-4"
                                height={160}
                            />
                        </div>
                        <div>
                            <label className="font-semibold text-gray-700 dark:text-gray-200">
                                Antecedente ocular
                            </label>
                        </div>
                        <div>
                            <div className="grid grid-cols-2 sm:grid-cols-3 px-4 gap-y-4 w-full ">
                                <InlineCheckbox
                                    value={patient?.strabismus}
                                    handleChange={handlePatient}
                                    name="strabismus"
                                    label="Estrabismo"
                                />
                                <InlineCheckbox
                                    value={patient?.glaucoma}
                                    handleChange={handlePatient}
                                    name="glaucoma"
                                    label="Glaucoma"
                                />
                            </div>
                            <TextEditor
                                name="othersOcular"
                                label=""
                                value={patient?.othersOcular}
                                handleChange={handlePatient}
                                error={null}
                                required={false}
                                containerClassName="px-4 pb-10 mt-4"
                                height={160}
                            />
                        </div>
                        <div>
                            <label className="font-semibold text-gray-700 dark:text-gray-200">
                                Cirugías oftalmológicas
                            </label>
                        </div>
                        <div>
                            <div className="grid grid-cols-2 sm:grid-cols-3 px-4 gap-y-4 w-full ">
                                <InlineCheckbox
                                    value={patient?.cataractSurgery}
                                    handleChange={handlePatient}
                                    name="cataractSurgery"
                                    label="Cataratas"
                                />
                                <InlineCheckbox
                                    value={patient?.glaucomaSurgery}
                                    handleChange={handlePatient}
                                    name="glaucomaSurgery"
                                    label="Glaucoma"
                                />
                                <InlineCheckbox
                                    value={patient?.refractiveSurgery}
                                    handleChange={handlePatient}
                                    name="refractiveSurgery"
                                    label="Refractiva"
                                />
                            </div>
                            <TextEditor
                                name="othersSurgery"
                                label=""
                                value={patient?.othersSurgery}
                                handleChange={handlePatient}
                                error={null}
                                required={false}
                                containerClassName="px-4 pb-10 mt-4"
                                height={160}
                            />
                        </div>
                        <div className="mt-10">
                            <label className="font-semibold text-gray-700 dark:text-gray-200">
                                Antecedentes familiares
                            </label>
                        </div>
                        <div>
                            <div className="grid grid-cols-4 font-medium text-gray-700 dark:text-gray-200 w-full -ml-2">
                                <label className="invisible">Esquina</label>
                                <label>Diabetes</label>
                                <label>HTA</label>
                                <label className="-ml-10">Glaucoma</label>
                            </div>
                            <div className="grid grid-cols-4 font-medium text-gray-700 dark:text-gray-200  w-full">
                                <label className="font-medium text-sm">
                                    Padre
                                </label>
                                <InlineCheckbox
                                    value={patient?.fatherDm}
                                    handleChange={handlePatient}
                                    name="fatherDm"
                                />
                                <InlineCheckbox
                                    value={patient?.fatherHta}
                                    handleChange={handlePatient}
                                    name="fatherHta"
                                />
                                <InlineCheckbox
                                    value={patient?.fatherGlaucoma}
                                    handleChange={handlePatient}
                                    name="fatherGlaucoma"
                                    className="-mx-5 focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded"
                                />
                            </div>
                            <div className="grid grid-cols-4 font-medium text-gray-700 dark:text-gray-200  w-full ">
                                <label className="font-medium text-sm">
                                    Madre
                                </label>
                                <InlineCheckbox
                                    value={patient?.motherDm}
                                    handleChange={handlePatient}
                                    name="motherDm"
                                />
                                <InlineCheckbox
                                    value={patient?.motherHta}
                                    handleChange={handlePatient}
                                    name="motherHta"
                                />
                                <InlineCheckbox
                                    value={patient?.motherGlaucoma}
                                    handleChange={handlePatient}
                                    name="motherGlaucoma"
                                    className="-mx-5 focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded"
                                />
                            </div>
                            <div className="grid grid-cols-4 font-medium text-gray-700 dark:text-gray-200  w-full">
                                <label className="font-medium text-sm">
                                    Hermanos
                                </label>
                                <InlineCheckbox
                                    value={patient?.siblingsDm}
                                    handleChange={handlePatient}
                                    name="siblingsDm"
                                />
                                <InlineCheckbox
                                    value={patient?.siblingsHta}
                                    handleChange={handlePatient}
                                    name="siblingsHta"
                                />
                                <InlineCheckbox
                                    value={patient?.siblingsGlaucoma}
                                    handleChange={handlePatient}
                                    name="siblingsGlaucoma"
                                    className="-mx-5 focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded"
                                />
                            </div>
                            <div className="grid grid-cols-4 font-medium text-gray-700 dark:text-gray-200  w-full">
                                <label className="font-medium text-sm">
                                    Otros
                                </label>
                                <InlineCheckbox
                                    value={patient?.otherDm}
                                    handleChange={handlePatient}
                                    name="otherDm"
                                />
                                <InlineCheckbox
                                    value={patient?.otherHta}
                                    handleChange={handlePatient}
                                    name="otherHta"
                                />
                                <InlineCheckbox
                                    value={patient?.otherGlaucoma}
                                    handleChange={handlePatient}
                                    name="otherGlaucoma"
                                    className="-mx-5 focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded"
                                />
                            </div>
                            <TextEditor
                                name="othersFamily"
                                label=""
                                value={patient?.othersFamily}
                                handleChange={handlePatient}
                                error={null}
                                required={false}
                                containerClassName="px-4 pb-10 mt-4"
                                height={160}
                            />
                        </div>
                    </div>
                    <div className="w-full pt-6 px-4">
                        <div>
                            <label className="font-semibold text-gray-700 dark:text-gray-200">
                                Medicamentos
                            </label>
                        </div>
                        <TextEditor
                            name="medications"
                            label=""
                            value={patient?.medications}
                            handleChange={handlePatient}
                            error={null}
                            required={false}
                            containerClassName="px-4 pb-10"
                            height={160}
                        />
                    </div>
                </div>
            </div>
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button
                    type="button"
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary sm:col-start-2 sm:text-sm"
                    onClick={() => {
                        handleSubmitPatient();
                    }}
                >
                    {loadingSubmitRecords ? (
                        <div className="w-5 h-5 mx-5 border-b-2 border-white rounded-full animate-spin"></div>
                    ) : (
                        "Guardar"
                    )}
                </button>
                <button
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:col-start-1 sm:text-sm"
                    onClick={() => setOpenRecords(false)}
                >
                    Cancelar
                </button>
            </div>
        </>
    );

    // eslint-disable-next-line no-unused-vars
    const constancies = (
        <div>
            <div>
                <div className="text-center">
                    <Dialog.Title
                        as="h3"
                        className="text-xl leading-6 font-semibold text-gray-900 dark:text-white"
                    >
                        Generar constancia
                    </Dialog.Title>
                    <div className="flex-col space-y-4 py-5 sm:p-6">
                        <SelectInput
                            className="shadow-sm w-full mt-1 mx-auto pr-12 border border-gray-300 block sm:text-sm rounded-md input-base"
                            containerStyle="w-fit mx-auto"
                            value={constancyType}
                            handleChange={handleConstancyType}
                            options={constancyTypes.map((element) => (
                                <option
                                    value={element.value}
                                    label={element.name}
                                >
                                    {element.name}
                                </option>
                            ))}
                        />
                    </div>
                    {constancyType === 1 && (
                        <>
                            <div className="flex gap-3 w-fit">
                                <p className="mt-2">Días de reposo</p>
                                <TextInput
                                    min={1}
                                    containerClassName="w-fit"
                                    className="shadow-sm pl-2 block w-1/2 sm:text-sm rounded-md input-base"
                                    value={constancy?.restDays}
                                    name="restDays"
                                    handleChange={handleConstancy}
                                    type="number"
                                />
                            </div>
                        </>
                    )}
                    {constancyType === 2 && (
                        <>
                            <TextArea
                                containerClassName="w-[450px]"
                                label="Descripción"
                                value={constancy?.text}
                                name="text"
                                handleChange={handleConstancy}
                            />
                        </>
                    )}
                </div>
            </div>
            {downloadError && (
                <p className="mt-3 text-sm text-red-600">{downloadError}</p>
            )}
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button
                    type="button"
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary sm:col-start-2 sm:text-sm"
                    onClick={() => submitConstancy()}
                >
                    {loadingSubmitConstancy ? (
                        <div className="w-5 h-5 mx-5 border-b-2 border-white rounded-full animate-spin"></div>
                    ) : (
                        "Aceptar"
                    )}
                </button>
                <button
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:col-start-1 sm:text-sm"
                    onClick={() => setOpenConstancies(false)}
                >
                    Cancelar
                </button>
            </div>
        </div>
    );

    const documentModal = (
        <div>
            <div className="max-h-[90dvh] overflow-y-auto overflow-x-hidden">
                <div className="text-center flex flex-col gap-6">
                    <Dialog.Title
                        as="h3"
                        className="text-xl leading-6 font-semibold text-gray-900 dark:text-white"
                    >
                        Documentos
                    </Dialog.Title>
                    <div className="text-left">
                        {documents.length > 0 && (
                            <Table
                                actiontext="Ver"
                                setSelectedDocument={patientDocument}
                                document={true}
                                columns={columns}
                                rows={documents}
                            />
                        )}
                        {documents.length === 0 && (
                            <p className="text-center">
                                No se han encontrado documentos
                            </p>
                        )}
                    </div>
                    <div>
                        <FileInput
                            multiple={true}
                            labelClassName="text-sm font-medium leading-[20px] text-[#374151] dark:text-gray-200"
                            buttonText="Adjuntar archivo"
                            handleChange={(name, files) =>
                                handleFileSelect(files)
                            }
                            name="document"
                        />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-black mt-2">
                            {patientDocument.documents.map((doc, index) => (
                                <div
                                    key={index}
                                    className="flex items-center gap-2 mb-2"
                                >
                                    <input
                                        type="text"
                                        value={doc.name}
                                        onChange={(e) => {
                                            const updated = [
                                                ...patientDocument.documents,
                                            ];
                                            updated[index].name =
                                                e.target.value;
                                            setPatientDocument({
                                                ...patientDocument,
                                                documents: updated,
                                            });
                                        }}
                                        className="border rounded p-1"
                                    />
                                    <span className="text-sm text-gray-500">
                                        .{doc.extension}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="flex flex-col gap-1">
                        <button
                            type="button"
                            onClick={() =>
                                setPatientDocument({ documents: [] })
                            }
                            className="flex justify-center h-fit  gap-2 py-2 px-4 border rounded-md shadow-sm text-sm font-medium text-primary bg-transparent border-primary"
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary sm:col-start-2 sm:text-sm"
                            onClick={() => setOpenDocuments(false)}
                        >
                            Continuar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="bg-gray-100 dark:bg-gray-800 min-h-screen">
            <Sidebar
                currentScreen={"Pacientes"}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />
            <Modal
                content={patientRecords}
                open={openRecords}
                setOpen={setOpenRecords}
                size="sm:max-w-4xl w-full"
            />
            <Modal
                content={
                    <LastEyeglassPrescription
                        patient={patient}
                        setOpen={setOpenLastsPrescription}
                    />
                }
                open={openLastsPrescription}
                setOpen={setOpenLastsPrescription}
                size="sm:max-w-4xl w-full"
            />
            {/* <Modal content={constancies} open={openConstancies} setOpen={setOpenConstancies} size='sm:max-w-2xl w-fit' /> */}
            <Modal
                content={documentModal}
                open={openDocuments}
                setOpen={setOpenDocuments}
                size="sm:max-w-2xl w-full"
            />
            <div className="md:pl-64 flex flex-col flex-1">
                <div className="sticky top-0 z-10 md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3 bg-gray-100 dark:bg-gray-800">
                    <button
                        type="button"
                        className="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
                        onClick={() => setSidebarOpen(true)}
                    >
                        <span className="sr-only">Open sidebar</span>
                        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                    </button>
                </div>
                {hasSelectedSubtype || idConsultation ? (
                    <>
                        <div className="flex flex-wrap sm:flex-nowrap justify-between flex-1 sm:ml-6 mt-6 gap-y-4">
                            <Breadcrumbs pages={pages} />
                            <div className="flex flex-col sm:flex-row flex-wrap justify-center sm:justify-end gap-3 w-full sm:w-auto">
                                <button
                                    type="button"
                                    onClick={() => setOpenRecords(true)}
                                    className="mr-8 ml-4 sm:ml-0 items-center px-4 py-2 border border-primary text-base font-medium rounded-md shadow-sm text-primary bg-white dark:bg-gray-900 hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                >
                                    Antecedentes
                                </button>
                                <button
                                    type="button"
                                    onClick={() =>
                                        setOpenLastsPrescription(true)
                                    }
                                    className="mr-8 ml-4 sm:ml-0 items-center px-4 py-2 border border-primary text-base font-medium rounded-md shadow-sm text-primary bg-white dark:bg-gray-900 hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                >
                                    Última graduación recetada
                                </button>
                                {/* <button
                                        type="button"
                                        onClick={() => setOpenConstancies(true)}
                                        className="mr-8 ml-4 sm:ml-0 items-center px-4 py-2 border border-primary text-base font-medium rounded-md shadow-sm text-primary bg-white dark:bg-gray-900 hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                    >
                                        Constancias
                                    </button> */}
                                <button
                                    type="button"
                                    onClick={() => setOpenDocuments(true)}
                                    className="mr-8 ml-4 sm:ml-0 items-center px-4 py-2 border border-primary text-base font-medium rounded-md shadow-sm text-primary bg-white dark:bg-gray-900 hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                >
                                    Documentos
                                </button>
                                {idConsultation ? (
                                    <>
                                    <button
                                        type="button"
                                        onClick={(event) => handleSubmit(event, false)}
                                        className="mr-8 ml-4 sm:ml-0 items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                    >
                                        {loadingSubmit ? (
                                            <div className="w-5 h-5 mx-5 border-b-2 border-white rounded-full animate-spin"></div>
                                        ) : (
                                            "Guardar"
                                        )}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={(event) => handleSubmit(event, true)}
                                        className="mr-8 ml-4 sm:ml-0 items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                    >
                                        {loadingSubmit ? (
                                            <div className="w-5 h-5 mx-5 border-b-2 border-white rounded-full animate-spin"></div>
                                        ) : (
                                            "Guardar y Finalizar"
                                        )}
                                    </button>
                                    </>
                                ) : (
                                    <>
                                    <button
                                        type="button"
                                        onClick={(event) => handleSubmit(event, false)}
                                        className="mr-8 ml-4 sm:ml-0 items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                    >
                                        {loadingSubmit ? (
                                            <div className="w-5 h-5 mx-5 border-b-2 border-white rounded-full animate-spin"></div>
                                        ) : (
                                            "Guardar"
                                        )}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={(event) => handleSubmit(event, true)}
                                        className="mr-8 ml-4 sm:ml-0 items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                    >
                                        {loadingSubmit ? (
                                            <div className="w-5 h-5 mx-5 border-b-2 border-white rounded-full animate-spin"></div>
                                        ) : (
                                            "Guardar y Finalizar"
                                        )}
                                    </button>
                                    </>
                                )}
                            </div>
                        </div>
                        <div>
                            <h5 className="text-3xl sm:ml-6 text-gray-900 dark:text-white font-bold px-5 py-2 rounded-lg">
                                Fecha:{" "}
                                {consultation.consultationDate
                                    ? consultation.consultationDate
                                          .split("-")
                                          .reverse()
                                          .join("-")
                                    : ""}
                            </h5>
                        </div>
                        {(submitError.nonFieldErrors ||
                            submitError.detail ||
                            submitError.medications) && (
                            <div className="px-12 mt-4 text-sm text-red-600 text-right">
                                {submitError.nonFieldErrors && (
                                    <div>{submitError.nonFieldErrors}</div>
                                )}
                                {submitError.detail && (
                                    <div>{submitError.detail}</div>
                                )}
                                {submitError.medications &&
                                    typeof submitError.medications ===
                                        "string" && (
                                        <div>{submitError.medications}</div>
                                    )}
                            </div>
                        )}
                        <main className="flex flex-1 flex-col lg:flex-row">
                            <div className="mt-8 w-full px-4 sm:px-12">
                                <div className="sm:hidden mx-4 mb-4">
                                    <label htmlFor="tabs" className="sr-only">
                                        Seleccione una página
                                    </label>
                                    {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
                                    {/* <select
                                        onChange={(event) => changeTab(event.target.value)}
                                        id="tabs"
                                        name="tabs"
                                        className="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md"
                                        defaultValue={tabs.find((tab) => tab.current).name}
                                    >
                                        {tabs.map((tab) => (
                                            <option key={tab.name}>{tab.name}</option>
                                        ))}
                                    </select> */}
                                </div>
                                <div className="flex gap-10 mb-4">
                                    <nav
                                        className="flex gap-x-4 gap-y-2 overflow-auto"
                                        aria-label="Tabs"
                                    >
                                        {tabs.map((tab) => (
                                            <button
                                                type="button"
                                                key={tab.name}
                                                className={classNames(
                                                    tab.current
                                                        ? "bg-[#C8E5F2] text-[#48B7E9]"
                                                        : "text-gray-500 hover:text-gray-700 dark:hover:text-[#48B7E9]",
                                                    "px-4 py-2 font-semibold text-xs rounded-md uppercase leading-4"
                                                )}
                                                onClick={() =>
                                                    changeTab(tab.name)
                                                }
                                                aria-current={
                                                    tab.current
                                                        ? "page"
                                                        : undefined
                                                }
                                            >
                                                {tab.name}
                                            </button>
                                        ))}
                                    </nav>
                                </div>
                                <div className="sm:mx-4 lg:ml-0">
                                    <div className="bg-white dark:bg-gray-900 my-2 max-w-screen shadow border flex-1 border-gray-300 dark:border-gray-700 rounded-lg divide-y divide-gray-800">
                                        <form>
                                            <FormNewConsultation
                                                idConsultation={idConsultation}
                                                medicines={medicines}
                                                surgeries={surgeries}
                                                doctors={doctors}
                                                userId={userId}
                                                handleSubmit={handleSubmit}
                                                handleChange={handleChange}
                                                history={history}
                                                refractionRecords={
                                                    history.consultationList
                                                        ? history?.consultationList.filter(
                                                            (element) =>
                                                                element.refraction &&
                                                                Object.entries(
                                                                    element.refraction
                                                                ).some(
                                                                    ([key, value]) =>
                                                                        key !== "id" &&
                                                                        key !== "generalObservations" &&
                                                                        value !== null &&
                                                                        value !== undefined &&
                                                                        value !== ""
                                                                )
                                                        )
                                                        : undefined
                                                }
                                                medicationsRecords={
                                                    history.consultationList
                                                        ? history?.consultationList.filter(
                                                              (element) =>
                                                                  element.medications
                                                          )
                                                        : undefined
                                                }
                                                loadingSubmit={loadingSubmit}
                                                consultation={consultation}
                                                changeTab={changeTab}
                                                tab={tab}
                                                age={getAge(patient?.birthdate)}
                                                handleError={handleError}
                                                errors={errors}
                                                printInsurance={printInsurance}
                                                setPrintInsurance={setPrintInsurance}
                                                patient={patient}
                                            />
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <Toaster />
                        </main>
                    </>
                ) : (
                    <>
                        <div className="flex flex-col justify-between flex-1 mt-6 gap-y-4">
                            <div className="ml-4">
                                <Breadcrumbs pages={pages} />
                            </div>
                            <main className="flex flex-1 flex-col lg:flex-row h-full">
                                <div className="mt-8 w-full h-full">
                                    <main className="flex-1 bg-gray-50 dark:bg-gray-900 px-32 py-16 h-full">
                                        <p className="font-bold text-[30px] text-[#4B5563] dark:text-gray-200 leading-[36px] text-center">
                                            Seleccioná el tipo de consulta
                                        </p>
                                        <div className="grid grid-cols-1 w-full mt-10 justify-center items-center gap-4">
                                            {hasSelectedType ? (
                                                <>
                                                    {consultation.consultationCategory ===
                                                    1
                                                        ? consultationASubtypes.map(
                                                              (type) => (
                                                                  <div
                                                                      key={
                                                                          type.name
                                                                      }
                                                                      onClick={() => (
                                                                          handleChange(
                                                                              "consultationType",
                                                                              type.value
                                                                          // eslint-disable-next-line no-sequences
                                                                          ),
                                                                          setHasSelectedSubtype(
                                                                              true
                                                                          )
                                                                      )}
                                                                      className="relative w-3/5 mx-auto cursor-pointer rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center gap-x-3 hover:border-gray-400"
                                                                  >
                                                                      <p className="w-fit mx-auto">
                                                                          {
                                                                              type.name
                                                                          }
                                                                      </p>
                                                                  </div>
                                                              )
                                                          )
                                                        : consultationBSubtypes.map(
                                                              (type) => (
                                                                  <div
                                                                      key={
                                                                          type.name
                                                                      }
                                                                      onClick={() => (
                                                                          handleChange(
                                                                              "consultationType",
                                                                              type.value
                                                                          // eslint-disable-next-line no-sequences
                                                                          ),
                                                                          setHasSelectedSubtype(
                                                                              true
                                                                          )
                                                                      )}
                                                                      className="relative w-3/5 mx-auto cursor-pointer rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center gap-x-3 hover:border-gray-400"
                                                                  >
                                                                      <p className="w-fit mx-auto">
                                                                          {
                                                                              type.name
                                                                          }
                                                                      </p>
                                                                  </div>
                                                              )
                                                          )}
                                                </>
                                            ) : (
                                                consultationTypes.map(
                                                    (type) => (
                                                        <div
                                                            key={type.name}
                                                            onClick={() => (
                                                                handleChange(
                                                                    "consultationCategory",
                                                                    type.value
                                                                // eslint-disable-next-line no-sequences
                                                                ),
                                                                setHasSelectedType(
                                                                    true
                                                                )
                                                            )}
                                                            className="relative w-3/5 mx-auto cursor-pointer rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center gap-x-3 hover:border-gray-400"
                                                        >
                                                            <p className="w-fit mx-auto">
                                                                {type.name}
                                                            </p>
                                                        </div>
                                                    )
                                                )
                                            )}
                                        </div>
                                    </main>
                                </div>
                            </main>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

const LastEyeglassPrescription = ({ patient, setOpen }) => {
    return (
        <>
            <div>
                <div className="mt-3 text-left sm:mt-5">
                    <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-semibold text-gray-900 dark:text-white mb-5"
                    >
                        Última graduación recetada
                    </Dialog.Title>
                    <div>
                        <h1 className="text-lg leading-6 font-medium text-gray-900 dark:text-white">
                            Visión lejana
                        </h1>
                        <div className="grid grid-cols-4 gap-4 mt-4 ">
                            <p className="text-end mt-7 dark:text-white">OD</p>
                            <TextInput
                                value={
                                    patient?.lastEyeglassPrescription
                                        ?.farVisionSphericalRight
                                }
                                disabled={true}
                                name="farVisionSphericalRight"
                                label="Esf"
                                labelClassName="w-full text-center block"
                            />
                            <TextInput
                                value={
                                    patient?.lastEyeglassPrescription
                                        ?.farVisionCylindricalRight
                                }
                                disabled={true}
                                name="farVisionCylindricalRight"
                                label="Cil."
                                labelClassName="w-full text-center block"
                            />
                            <TextInput
                                value={
                                    patient?.lastEyeglassPrescription
                                        ?.farVisionAxisRight
                                }
                                disabled={true}
                                name="farVisionAxisRight"
                                label="Eje"
                                labelClassName="w-full text-center block"
                            />
                            <p className="text-end mt-2 dark:text-white">OI</p>
                            <TextInput
                                value={
                                    patient?.lastEyeglassPrescription
                                        ?.farVisionSphericalLeft
                                }
                                disabled={true}
                                name="farVisionSphericalLeft"
                            />
                            <TextInput
                                value={
                                    patient?.lastEyeglassPrescription
                                        ?.farVisionCylindricalLeft
                                }
                                disabled={true}
                                name="farVisionCylindricalLeft"
                            />
                            <TextInput
                                value={
                                    patient?.lastEyeglassPrescription
                                        ?.farVisionAxisLeft
                                }
                                disabled={true}
                                name="farVisionAxisLeft"
                            />
                        </div>
                    </div>
                    <div>
                        <h1 className="text-lg leading-6 font-medium text-gray-900 dark:text-white">
                            Visión cercana
                        </h1>
                        <div className="grid grid-cols-4 gap-4 mt-4 ">
                            <p className="text-end mt-7 dark:text-white">OD</p>
                            <TextInput
                                value={
                                    patient?.lastEyeglassPrescription
                                        ?.nearVisionSphericalRight
                                }
                                disabled={true}
                                name="nearVisionSphericalRight"
                                label="Esf"
                                labelClassName="w-full text-center block"
                            />
                            <TextInput
                                value={
                                    patient?.lastEyeglassPrescription
                                        ?.nearVisionCylindricalRight
                                }
                                disabled={true}
                                name="nearVisionCylindricalRight"
                                label="Cil."
                                labelClassName="w-full text-center block"
                            />
                            <TextInput
                                value={
                                    patient?.lastEyeglassPrescription
                                        ?.nearVisionAxisRight
                                }
                                disabled={true}
                                name="nearVisionAxisRight"
                                label="Eje"
                                labelClassName="w-full text-center block"
                            />
                            <p className="text-end mt-2 dark:text-white">OI</p>
                            <TextInput
                                value={
                                    patient?.lastEyeglassPrescription
                                        ?.nearVisionSphericalLeft
                                }
                                disabled={true}
                                name="nearVisionSphericalLeft"
                            />
                            <TextInput
                                value={
                                    patient?.lastEyeglassPrescription
                                        ?.nearVisionCylindricalLeft
                                }
                                disabled={true}
                                name="nearVisionCylindricalLeft"
                            />
                            <TextInput
                                value={
                                    patient?.lastEyeglassPrescription
                                        ?.nearVisionAxisLeft
                                }
                                disabled={true}
                                name="nearVisionAxisLeft"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 mt-5">
                        <InlineCheckbox
                            value={
                                patient?.lastEyeglassPrescription?.photochromic
                            }
                            className="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded input-base"
                            disabled={true}
                            name="photochromic"
                            label="Fotocromático"
                        />
                        <InlineCheckbox
                            value={patient?.lastEyeglassPrescription?.monofocal}
                            className="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded input-base"
                            disabled={true}
                            name="monofocal"
                            label="Monofocal"
                        />
                        <InlineCheckbox
                            value={patient?.lastEyeglassPrescription?.antiGlare}
                            className="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded input-base"
                            disabled={true}
                            name="antiGlare"
                            label="Antireflejo"
                        />
                        <InlineCheckbox
                            value={patient?.lastEyeglassPrescription?.bifocal}
                            className="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded input-base"
                            disabled={true}
                            name="bifocal"
                            label="Bifocal"
                        />
                        <InlineCheckbox
                            value={patient?.lastEyeglassPrescription?.uvx}
                            className="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded input-base"
                            disabled={true}
                            name="uvx"
                            label="UVX"
                        />
                        <InlineCheckbox
                            value={
                                patient?.lastEyeglassPrescription?.multifocal
                            }
                            className="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded input-base"
                            disabled={true}
                            name="multifocal"
                            label="Multifocal"
                        />
                        <InlineCheckbox
                            value={
                                patient?.lastEyeglassPrescription?.focalFilter
                            }
                            className="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded input-base"
                            disabled={true}
                            name="focalFilter"
                            label="Filtro azul"
                        />
                        <InlineCheckbox
                            value={patient?.lastEyeglassPrescription?.wideField}
                            className="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded input-base"
                            disabled={true}
                            name="wideField"
                            label="Campo Amplio"
                        />
                        <InlineCheckbox
                            value={
                                patient?.lastEyeglassPrescription?.contactLens
                            }
                            className="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded input-base"
                            disabled={true}
                            name="contactLens"
                            label="Lente de contacto"
                        />
                        <InlineCheckbox
                            value={
                                patient?.lastEyeglassPrescription?.contactLens
                            }
                            className="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded input-base"
                            disabled={true}
                            name="ultra_thin"
                            label="Ultra delgado"
                        />
                    </div>
                </div>
            </div>
            <div className="mt-5 sm:mt-6">
                <button
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:col-start-1 sm:text-sm"
                    onClick={() => setOpen(false)}
                >
                    Volver
                </button>
            </div>
        </>
    );
};
